import Decimal from 'decimal.js';

export function D(n) {
    return new Decimal(n);
}

const THOUSANDS_REGEX_1 = /(\d)(?=(\d{3})+\.)/g;
const THOUSANDS_REGEX_2 = /(\d)(?=(?:\d{3})+$)/g;

/// 数字(number|string) 转 千分符数字(string)
export function thousands(num, placeholder = '', precision) {
    if (num === undefined || num === null) return placeholder;

    let str = num.toString();
    const n = parseFloat(num);
    if (!isNaN(n) && typeof precision === 'number' && precision >= 0) {
        str = n.toFixed(precision);
    }

    const reg = str.indexOf('.') > -1 ? THOUSANDS_REGEX_1 : THOUSANDS_REGEX_2;
    return str.replace(reg, '$1,');
}

/**
 * 精确至指定小数位, 并将小数点末尾的0擦除掉
 */
export function toFixedAndEraseZero(value, digits) {
    const tempValue = parseFloat(value)
    if (Number.isNaN(tempValue)) return value
    return parseFloat(D(tempValue).toFixed(digits))
}
